/**
 * @desc: Copied from https://git.perkbox.io/backend-services/deals/blob/master/src/Framework/ErrorCodes/ErrorCodes.php
 */

enum PerksSettings {
  SettingsAlreadyExistForTenant  = "PBDEASettingAlreadyExistForTenant"
}
export default PerksSettings
